import { Loader } from "@circle-react-uikit/Loader";
import InfiniteScroll from "react-infinite-scroll-component";

import { classNames } from "@/react/helpers/twMergeWithCN";
import { useCircleV4 } from "@/react/hooks/useCircleV4";
import { useMemberAreaScrollContainerId } from "@/react/hooks/useMemberAreaScrollContainerId";
import type { CommunityMember } from "@/react/types/CommunityMember";

import { MemberCardWithConnection } from "./MemberCardWithConnection";

interface CardViewProps {
  canReceiveDmByMemberId: Record<number, boolean> | false;
  fetchNextPage: () => void;
  hasNextPage: boolean;
  members: CommunityMember[];
}

export const CardView = ({
  canReceiveDmByMemberId,
  fetchNextPage,
  hasNextPage,
  members,
}: CardViewProps) => {
  const scrollContainerId = useMemberAreaScrollContainerId();
  const { isCircleV4 } = useCircleV4();

  return (
    <InfiniteScroll
      style={{ overflow: "initial" }}
      scrollThreshold={0.8}
      next={fetchNextPage}
      hasMore={!!hasNextPage}
      loader={<Loader />}
      dataLength={members.length}
      scrollableTarget={scrollContainerId}
    >
      <ol
        className={classNames(
          "m-4 grid list-none auto-rows-fr grid-cols-[repeat(auto-fill,minmax(218px,1fr))] gap-5 md:m-0 lg:m-auto",
          isCircleV4 &&
            "grid-cols-[repeat(auto-fill,229px)] gap-4 justify-start",
        )}
        data-testid="directory_members_grid"
      >
        {members.map(member => (
          <MemberCardWithConnection
            key={member.id}
            member={member}
            canReceiveDmFromCurrentMember={
              canReceiveDmByMemberId === false
                ? false
                : (canReceiveDmByMemberId?.[member.id] ?? false)
            }
          />
        ))}
      </ol>
    </InfiniteScroll>
  );
};
